import { useContext,  useState } from "react"
import API from "./API"
import { Link, useNavigate, useParams } from "react-router"
import { useForm } from "react-hook-form"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { ModalContext } from './ModalContext';
import ApiResult from './ApiResult';
import { AdminPositionResponse } from "../../backend/src/api/dto"
import dayjs from "dayjs"
import AdminAddPositionRateToPosition from "./Modal/AdminAddPositionRateToPosition"
import ModalConfirmation from "./Modal/Confirmation"
import DisplayUsage from "./components/DisplayUsage"

type FormValues = {
    name: string
    description: string
    status: boolean
}


function Position() {

    const params = useParams();
    let navigate = useNavigate();

    const [data, setData] = useState<AdminPositionResponse>({
        position: {
            positionId: 0,
            name: '',
            description: '',
            status: false
        },
        usage: [],
        rates: []
    })
    const [apiResult, setApiResult] = useState<null | { status: boolean, message?: string[] }>(null)
    const [showModal, closeModal] = useContext(ModalContext);

    const [loading, setLoading] = useState(true)
    const { register, control, getValues } = useForm<FormValues>({
        defaultValues: async () => {
            if (params.positionId !== "0") {
                const result = await API.getPosition(params.positionId ?? 0)
                setData(prevData => {
                    return {
                        ...prevData,
                        ...result
                    }
                })
                setLoading(false)
                return result.position
            } else {
                setLoading(false)
                return {
                    status: true,
                    name: '',
                    description: ''
                }
            }
        }
    })

    const reloadData = (): Promise<any> => {
        setLoading(true)
        return API.getPosition(params.positionId ?? 0).then(position => {
            setData(prevData => {
                return {
                    ...prevData,
                    ...position,

                }
            })
            setLoading(false)
        }).catch(e => {
            setLoading(false)
        })
    }

    const addPositionRate = () => {
        return Promise.resolve();
    }

    const removeRate = (positionRateId: number) => {
        return Promise.resolve();
    }


    const addPosition = () => {
        API.addPosition(getValues()).then((res) => {
            console.log(res)
            setApiResult(null)
            navigate('/dashboard/position')
        }).catch((e) => {
            console.log(JSON.stringify(e))
            setApiResult(e)
        })
    }

    const savePosition = () => {
        API.savePosition(params.positionId ?? 0, getValues()).then((res) => {
            console.log(res)
            setApiResult(null)
            navigate('/dashboard/position')
        }).catch((e) => {
            console.log(JSON.stringify(e))
            setApiResult(e)
        })
    }

    const deletePosition = () => {
        return API.deletePosition(params.positionId ?? 0).then((res) => {
            console.log(res)
            setApiResult(null)
            navigate('/dashboard/position')
        }).catch((e) => {
            console.log(JSON.stringify(e))
            setApiResult(e)
        })
    }


    if (loading) {
        return (
            <div className="p-3">
                <div className="card">
                    <div className="card-header" style={{ height: '55px' }}>
                        <div className="mt-2">Pozícia: ...</div>
                    </div>
                    <div className="card-body">
                        Nahrávam
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="p-3">
            <div className="card">
                <div className="card-header " style={{ height: '55px' }}>
                    <div className="row">
                        <div className="col-1">
                            <span className=""><Link to="/dashboard/position" className="btn btn-primary"><FontAwesomeIcon fixedWidth icon={["fas", "arrow-left"]} /> Späť</Link></span>
                        </div>
                        <div className="col-6">
                            <div className="mt-2">Pozícia: <strong>{
                                params.positionId === "0" ? '[ Vytvoriť novú ]' : getValues().name}</strong></div>
                        </div>
                        <div className="col-5 text-end">
                            {
                                params.positionId === "0" ?
                                    <button className="btn btn-primary" onClick={addPosition}><FontAwesomeIcon fixedWidth icon={["fas", "plus"]} />  Pridať pozíciu</button>
                                    :
                                    <>
                                        {
                                            !loading && !data.usage.length ?
                                                <button className="btn btn-danger me-3" onClick={() => showModal(
                                                    <ModalConfirmation
                                                        confirm={deletePosition}
                                                        title={"Naozaj zmazať pozíciu?"}
                                                        text="Zmažú sa aj hodinové sadzby!" />
                                                )}><FontAwesomeIcon fixedWidth icon={["fas", "trash"]} />  Zmazať pozíciu</button>
                                                : null
                                        }
                                        <button className="btn btn-primary" onClick={savePosition}><FontAwesomeIcon fixedWidth icon={["fas", "floppy-disk"]} />  Uložiť pozíciu</button>

                                    </>

                            }
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <ApiResult errorObject={apiResult} />
                    <div className="row">
                        <div className="col-4">
                            <div className="row">
                                <div className="col-4 mt-1 text-end">
                                    <label className="form-label">Názov pozície</label>
                                </div>
                                <div className="col-auto">
                                    <input type="text" {...register("name")} className="form-control form-control-sm" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4 mt-1 text-end">
                                    <label className="form-label">Popis</label>
                                </div>
                                <div className="col-8">
                                    <textarea rows={6} {...register("description")} className="form-control form-control-sm" />
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-4  mt-1 text-end">
                                    <label className="form-label">Aktívna</label>
                                </div>
                                <div className="col-8  mt-1">
                                    <div className="form-check">

                                        <input className="form-check-input" {...register("status")} type="checkbox" />
                                        <label className="form-check-label">

                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="offset-4 col-4">
                            {
                                params.positionId !== "0" ?
                                    <>
                                        <h4>Odkazy na túto pozíciu</h4>
                                        <DisplayUsage data={data.usage} />

                                    </>
                                    : null
                            }
                        </div>
                    </div>

                    <hr />

                    <div className="card mt-5">
                        <div className="card-header">
                            <div className="row">
                                <div className="col-6">
                                    <div className="mt-1 h7"><span className="text-primary me-2"><FontAwesomeIcon fixedWidth icon={["fas", "code-compare"]} /><FontAwesomeIcon fixedWidth icon={["fas", "arrow-right"]} /><FontAwesomeIcon fixedWidth icon={["fas", "money-bill-trend-up"]} /></span> Hodinové sadzby tejto pozície</div>
                                </div>
                                <div className="col-6 text-end">
                                    {
                                        params.positionId === "0" ?
                                            <button className="btn btn-success btn-sm" disabled><FontAwesomeIcon fixedWidth icon={["fas", "plus"]} /> Pridať hodinovú sadzbu</button>
                                            :
                                            <button className="btn btn-success btn-sm" onClick={
                                                () => showModal(
                                                    <AdminAddPositionRateToPosition
                                                        item={null}
                                                        parent={data.position}
                                                        reload={reloadData}
                                                        addFunction={addPositionRate}
                                                    />
                                                )
                                            }><FontAwesomeIcon fixedWidth icon={["fas", "plus"]} /> Pridať hodinovú sadzbu</button>

                                    }

                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            {
                                params.positionId !== "0" ?
                                    <table className="table table-bordered table-sm table-hover">
                                        <thead>
                                            <tr>
                                                <th>Sadzba na hodinu</th>
                                                <th className="text-center" style={{ width: '130px' }}>Dátum od</th>
                                                <th style={{ width: '30px' }}></th>
                                                <th className="text-center" style={{ width: '130px' }}>Dátum do</th>
                                                <th className="text-center" style={{ width: '230px' }}>Akcia</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                data.rates.map(rate => {
                                                    return (
                                                        <tr>
                                                            <td>&euro; {rate.ratePerHour}</td>
                                                            <td className="text-center">{rate.startDate ? dayjs(rate.startDate).format('YYYY-MM-DD') : null}</td>
                                                            <td className={rate.stillWorks ? 'bg-success-subtle' : 'bg-danger-subtle'}></td>
                                                            <td className="text-center">{rate.endDate ? dayjs(rate.endDate).format('YYYY-MM-DD') : null}</td>
                                                            <td className="text-center">

                                                                <button className="btn btn-danger btn-sm me-3" onClick={
                                                                    () => showModal(
                                                                        <ModalConfirmation
                                                                            confirm={() => removeRate(rate.positionRateId)}
                                                                            title="Potvrdiť zmazanie hodinovej sadzby"
                                                                        ><div>
                                                                                <table className="table table-bordered">
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <td>Hodinová sadzba</td>
                                                                                            <td>{rate.ratePerHour}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>Od</td>
                                                                                            <td>{rate.startDate}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>Do</td>
                                                                                            <td>{rate.endDate}</td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            </div>
                                                                        </ModalConfirmation>
                                                                    )
                                                                }><FontAwesomeIcon fixedWidth icon={["fas", "trash"]} /> Zmazať</button>
                                                                <button className="btn btn-primary btn-sm" onClick={
                                                                    () => showModal(
                                                                        <AdminAddPositionRateToPosition
                                                                            item={rate}
                                                                            parent={data.position}
                                                                            reload={reloadData}
                                                                            addFunction={addPositionRate}
                                                                        />
                                                                    )
                                                                }><FontAwesomeIcon fixedWidth icon={["fas", "pen"]} /> Upraviť</button>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                    :
                                    <div className="text-center">Bude možné pridať po vytvorení pozície</div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default Position